// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop_Backdrop_pqZca"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Modal/Backdrop/Backdrop.css
// module id = 320
// module chunks = 4